import Icon from 'components/Icon';

const SidebarNav = ({ isOpened, toggleOpened, collectionName, children }) => (
  <nav
    className={cx('search-nav', {
      'search-nav_opened': isOpened,
    })}
  >
    <div className="search-nav__section" onClick={toggleOpened}>
      <div className="search-nav__section-title">{collectionName}</div>
      <Icon icon="arrow-accordion" className="search-nav__section-icon" />
    </div>
    {children}
  </nav>
);

export default SidebarNav;
